export default __webpack_public_path__ + "static/media/MilanM.32c9eef7.png";